import * as ss from 'superstruct';

/** Whether `value` is a real calendar date written `yyyy-MM-dd`. */
export const isIsoDate = (value: string): boolean => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!m) {
    return false;
  }
  const [year, month, day] = [Number(m[1]), Number(m[2]), Number(m[3])];
  // Not Date.UTC, which maps years 0-99 to 1900-1999.
  const date = new Date(0);
  date.setUTCFullYear(year, month - 1, day);
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
};

/** A calendar date written `yyyy-MM-dd`. */
export const IsoDate = ss.refine(ss.string(), 'IsoDate', (value) =>
  isIsoDate(value) ? true : `Expected a yyyy-MM-dd date, got "${value}"`,
);
export type IsoDate = ss.Infer<typeof IsoDate>;
